import { CoaGroup, RowExportTypeExcel } from "types";
import { excel } from "utils";

export function exportExcel({ dataList, location, fillTab }: {
  dataList: CoaGroup[],
  location: any
  fillTab: string
}) {

  
  const sortedData = sortByHierarchy(dataList).filter((item: any) => {
    return fillTab !== '' ? fillTab.includes(item.group_coa_code) : true
  });


  const columns = [
    { header: 'No', key: 'no', width: 5 },
    { header: 'CHQ', key: 'chq', width: 10 },
    { header: 'ACCOUNT', key: 'coa_code', width: 20 },
    { header: 'NAME', key: 'coa_name', width: 20 },
    { header: 'LOCATION', key: 'location', width: 20 },
    { header: 'LINKED', key: 'budget_coa', width: 20 },
    { header: 'LEVEL', key: 'level', width: 20 },
    { header: 'ACC TYPE', key: 'account_type', width: 20 },
    { header: 'BALANCE', key: 'balance', width: 20 },
  ];

  const dataMap: RowExportTypeExcel[] = sortedData.map((item: CoaGroup, index: number) => {

    const textBold = Boolean(item.account_type !== 'Detail');

    return {
      no: index + 1,
      chq: {
        text: item.cheque_coa ? 'v' : '',
        style: {
          alignment: {
            horizontal: 'center'
          }
        }
      },
      coa_code: {
        text: item.coa_code,
        style: {
          font: {
            bold: textBold,
          },
        }
      },
      coa_name: {
        text: item.coa_name,
        style: {
          font: {
            bold: textBold
          },
        }
      },
      location: {
        text: location.data?.find((loc: any) => loc.value === item.location_id?.toString())?.label || '',
        style: {
          font: {
            bold: textBold
          },
        }
      },
      budget_coa: {
        text: item.budget_coa ? "✔" : '',
        style: {
          font: {
            bold: true
          },
          alignment: {
            horizontal: 'center'
          }
        }
      },
      level: {
        text: formatLevel({
          headerLevel: item.header_level,
          coaLevel: item.coa_level
        }),
        style: {
          font: {
            bold: textBold
          },
          alignment: {
            horizontal: 'center'
          }
        }
      },
      account_type: {
        text: item.account_type_name,
        style: {
          font: {
            bold: textBold
          }
        }
      },
      balance: {
        text: Number(item.opening_balance),
        style: {
          numFmt: '#,##0',
          font: {
            bold: textBold
          }
        }
      }
    }
  })

  excel({
    dataList: dataMap,
    column: columns,
    module: "ACCOUNTS",
    title: 'CHART OF ACCOUNT',
    fileName: 'Chart_of_Account',
  });
}

function formatLevel(props: {
  headerLevel: number,
  coaLevel: number
}) {
  if (!props.headerLevel && !props.coaLevel) return '';

  let level = '';

  switch (props.headerLevel) {
    case 1:
      level = 'H';
      break;
    case 2:
      level = 'S';
      break;
    case 3:
      level = 'D';
      break;
    default:
      return props.coaLevel?.toString() || '';
  }

  return `${props.coaLevel ? props.coaLevel + ' ' : ''}${level}`.trim();
}

function sortByHierarchy(dataList: any, parentId = -1) {
  const parentItems = dataList.filter((item: any) => item.parent_id === parentId);
  parentItems.sort((a: any, b: any) => a.coa_code.localeCompare(b.coa_code));
  
  return parentItems.flatMap((parent : any) => {
    return [parent, ...sortByHierarchy(dataList, parent.coa_id)];
  });
}